import UiVersionSwitcher from '@/components/ui/custom/UiVersionSwitcher';
import DeprecatedStudentDashboardView from '@/pages/_deprecated/StudentDashboardView';
import StudentDashboardView from '@/pages/dashboard/StudentDashboardView';

export default function StudentDashboardViewSwitcher() {
  return (
    <UiVersionSwitcher scope="studentDashboard">
      <UiVersionSwitcher.Legacy>
        <DeprecatedStudentDashboardView />
      </UiVersionSwitcher.Legacy>
      <UiVersionSwitcher.Modern>
        <StudentDashboardView />
      </UiVersionSwitcher.Modern>
    </UiVersionSwitcher>
  );
}
